import { getSmsAlertSettings, SMS_ALERT_ONCE_A_DAY_INTERVAL_MS, SMS_ALERT_FREQUENCY_ONCE_A_DAY } from './smsAlertSettings';

export const shouldShowSmsAlert = ({ remaining, settings, now, lastShownAt, newLogin, snoozedUntil }) => {
  if (remaining === null || remaining === undefined || !Number.isFinite(Number(remaining))) return false;
  const policy = getSmsAlertSettings(settings);
  if (Number(remaining) > policy.threshold || Date.parse(snoozedUntil) > now) return false;
  if (policy.frequency === 'login_only') return newLogin;
  const interval = policy.frequency === SMS_ALERT_FREQUENCY_ONCE_A_DAY ? SMS_ALERT_ONCE_A_DAY_INTERVAL_MS : policy.custom_minutes * 60000;
  return !lastShownAt || now - lastShownAt >= interval;
};
